import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useMemo } from 'react';
import { IconSvg } from 'shared/icon';
import { NavigationService } from 'services';
import Monitor from 'assets/img/monitor.png';
import { selectUserPermissions, selectHasClaimType } from 'app/auth/selectors';
import { useAppSelector } from 'store/hooks';
import { StyledButtonBlue } from 'components/styledComponents/button/Button.styled';
import { UserClaimTypes } from 'constants/enumTypes1';
import {
  StyledPermissionWrapper,
  StyledPermissionText,
  StyledPermissionTitle,
  StyledPermissionIcon,
  StyledPermissionSettings1,
  StyledPermissionSettings2,
} from './NoAccess.styled';

const NoAccess = () => {
  const { t } = useTranslation();

  const permissions = useAppSelector(selectUserPermissions);
  const isSuperAdmin = useAppSelector((state) => selectHasClaimType(state, UserClaimTypes.SuperAdmin));

  const hideLayout = useCallback(() => {
    const root = document.querySelector('#root');
    root?.querySelector('aside')?.classList?.add('hidden');
    root?.querySelector('.ant-layout-content')?.classList?.add('no-padding');
  }, []);

  const showLayout = () => {
    const root = document.querySelector('#root');
    const aside = root?.querySelector('aside');
    const content = root?.querySelector('.ant-layout-content');
    if (aside) {
      aside.classList.remove('hidden');
    }
    if (content) {
      content.classList.remove('no-padding');
    }
  };

  const hasPermissions = useMemo(() => (permissions && Object.keys(permissions).length) || isSuperAdmin, [permissions, isSuperAdmin]);

  useEffect(() => {
    if (!hasPermissions) {
      hideLayout();
    }
    return () => showLayout();
  }, [hideLayout, hasPermissions]);

  return (
    <StyledPermissionWrapper>
      <StyledPermissionIcon>
        <img alt="" src={Monitor} />
        <StyledPermissionSettings1>
          <IconSvg icon="PermissionSettingsIcon" width="3rem" height="3rem" />
        </StyledPermissionSettings1>
        <StyledPermissionSettings2>
          <IconSvg icon="PermissionSettingsIcon" width="5rem" height="5rem" />
        </StyledPermissionSettings2>
      </StyledPermissionIcon>
      <StyledPermissionTitle>{t('pageCantBeDisplayed')}</StyledPermissionTitle>
      <StyledPermissionText>{t('pageContentNotAvailable')}</StyledPermissionText>
      <div>
        <div onClick={() => NavigationService(!hasPermissions ? '/noAccessAccount' : '/')}>
          <StyledButtonBlue size="middle">{t('home')}</StyledButtonBlue>
        </div>
      </div>
    </StyledPermissionWrapper>
  );
};

export default NoAccess;
